/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import moment from "moment";
import { useTranslation } from "react-i18next";
// Components
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link as RouterLink } from "react-router-dom";
import Box from "components/Atoms/Box";
import TypographyV1 from "components/Atoms/Typography/TypographyV1";
import LanguagePicker from "components/LanguagePicker";
// Images
import inescTecLogo from "assets/images/inesctec.png";

function AuthFooter() {
  const year = moment().year();
  const { t } = useTranslation(["common"]);

  return (
    <Box component="footer" py={1}>
      <Grid container justifyContent="center">
        <Grid item xs={10} lg={8}>
          <Box display="flex" justifyContent="center" flexWrap="wrap" mb={1}>
            <Link
              href="https://inesctec.pt/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-block",
                transition: "opacity 0.2s",
                "&:hover": {
                  opacity: 0.7,
                },
              }}
            >
              <img
                src={inescTecLogo}
                alt="INESC TEC"
                style={{
                  height: "40px",
                  display: "block",
                }}
              />
            </Link>
          </Box>

          <Box sx={{ width: 90, mx: "auto", mb: 3 }}>
            <LanguagePicker fullWidth />
          </Box>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Box display="flex" justifyContent="center" mt={1} mb={3}>
            <Box mr={3}>
              <Link
                href="https://www.instagram.com/inesctec/"
                target="_blank"
                rel="noopener"
                sx={{ color: "#1e88e5" }}
              >
                <InstagramIcon fontSize="small" />
              </Link>
            </Box>
            <Box>
              <Link
                href="https://www.linkedin.com/company/inesc-tec"
                target="_blank"
                rel="noopener"
                sx={{ color: "#1e88e5" }}
              >
                <LinkedInIcon fontSize="small" />
              </Link>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={8} className="text-center">
          <TypographyV1
            variant="body2"
            sx={{
              color: "#1e88e5",
            }}
          >
            &copy; INESC TEC - Todos os direitos Reservados {year}.
          </TypographyV1>
        </Grid>
        <Grid item xs={12} lg={8} className="text-center">
          <Box display="flex" justifyContent="center" flexWrap="wrap" gap={2}>
            <RouterLink to="/privacy-policy" style={{ textDecoration: "none" }}>
              <TypographyV1
                variant="body2"
                sx={{
                  color: "#1e88e5",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("privacy_policy")}
              </TypographyV1>
            </RouterLink>
            <RouterLink to="/terms-and-conditions" style={{ textDecoration: "none" }}>
              <TypographyV1
                variant="body2"
                sx={{
                  color: "#1e88e5",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {t("terms_and_conditions")}
              </TypographyV1>
            </RouterLink>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AuthFooter;
